const Modals = {
  baseStyle: {},
  sizes: {
    standard: {
      height: "90%",
      maxW: "90%",
      overflowY: "auto",
    },
  },
  variants: {
    standard: {
      dialog: {
        height: "85%",
        maxW: "90%",
        overflowY: "auto",
        color: "black",
      },
      closeButton: {
        variant: "grayRounded",
      },
    },
    mini: {
      body: {
        pl: 8,
        pr: 8,
        pb: 8,
        pt: 4,
      },
      closeButton: {
        variant: "grayRounded",
      },
      header: {
        pl: 8,
        pr: 8,
        pb: 0,
      },
    },
    dataUpload: {
      dialogContainer: {
        justifyContent: "center",
        alignItems: "center",
      },
      dialog: {
        maxW: "30rem",
        overflowY: "auto",
        overflowX: "hidden",
        color: "black",
      },
      closeButton: {
        variant: "grayRounded",
      },
      body: {
        p: 0,
        justifyContent: "space-between",
      },
      footer: {
        justifyContent: "space-between",
      },
    },
  },
}

export default Modals
